import { put, select, takeLatest } from 'redux-saga/effects';

import { presenceActions } from 'components/presence/actions/presenceActions';

import { actions } from '../actions/visibility';
import { isMobilePWA } from '../utils/helpers';
const { presenceGet } = presenceActions;
export const { visibilityHidden, visibilityShown } = actions;

// Saga
export const visibility = [
  takeLatest(visibilityShown.toString(), visibilityShownGen),
];

function* visibilityShownGen() {
  if (isMobilePWA()) {
    const getProfile = (state) => state.settings.profile.profile;
    const profileState = yield select(getProfile);
    // Because we are on a mobile device and inside a PWA, we need to do a sanity check and that
    // means a refetch of a presence list.
    // This have the side effect that we also check if there are any active phone calls that this
    // agent currently not is assigned to (see function shouldReconnectToPhone()) in app.sagas.ts.

    yield put(presenceGet({ user_id: profileState.id }));
  }
}
